import { OrganizationRoute } from "#src/routes/organization";
import { RoutePath } from "#src/utils/route";

export const DevicesListRoutePath = OrganizationRoute.concat(
  new RoutePath({
    path: "/devices",
    title: "Device",
  })
);
